import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { act } from "react";
import { flushSync } from "react-dom";
import "./index.css";
import App from "./App";

// Testing helper for chromedp integration tests
declare global {
  interface Window {
    react_act_act: (cb: () => void) => void;
  }
}

window.react_act_act = function (cb) {
  act(() => {
    flushSync(cb);
  });
  flushSync(() => {});
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
